import styled from 'styled-components';

export const DateSingleHeaderStyled = styled.div`
  display: flex;
  gap: 24px;
  position: relative;
  width: 280px;

  & > * {
    display: grid;
    grid-gap: 4px;
    grid-template-columns: 160px auto;
    position: relative;

    z-index: 1;
  }
`;
